import React, { useState, useEffect, useRef } from 'react';
import './Landing_page.css';

import Img from '../addons/img/Img';
import useMediaQuery from './useMediaQuery'
import emailjs from '@emailjs/browser';



const IS_MOBILE_QUERY = '(max-width: 767px)';
let lastScrollY = 0;

function Landing_page({}) {

    const isMobile = useMediaQuery(IS_MOBILE_QUERY);

    const [show, setShow] = useState(true);
    const [formsended, setformsended] = useState(false);
    const [casestate, setcasestate] = useState(false);
    const [phonestate, setphonestate] = useState(false);
    const [formsendet, setformsendet] = useState(false);

    const lastScrollY = useRef(0);

    useEffect(() => {
        
        const handleScroll = () => {
        const scrollThreshold = 15; 
        const currentScrollY = window.scrollY;

        if (currentScrollY < 100) {
            setShow(true);
        } 
        else if (currentScrollY < lastScrollY.current && (lastScrollY.current - currentScrollY) > scrollThreshold) { 
            setShow(true); 
        } 
        else if (currentScrollY > lastScrollY.current && (currentScrollY - lastScrollY.current) > scrollThreshold) {
            setShow(false); 
        }

        lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
        window.removeEventListener('scroll', handleScroll);
        };

    }, []); 

    const scrollToBox11 = () => {
        const targetElement = document.getElementById('box-section-11');
        
        if (targetElement) {
            targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start' 
            });
        }
    };

    const [formData, setFormData] = useState({
        name: "",
        fname: "",
        phone: "",
        city: "",
        zip: "",
        msg: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const onFormSubmit = (e) => {
        e.preventDefault(); 
        handleSubmit(e);       
        sendEmail(e);           
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSde8e4tQ0eBSCJWxktRmoLSQe69eRQfu1W5Yp8dqrzpk6hDsA/formResponse';
        
        const payload = new URLSearchParams({
            'entry.1362683251': formData.name,
            'entry.481427896': formData.fname,
            'entry.1622509432': formData.phone,
            'entry.129141250': formData.city,
            'entry.1423158575': formData.zip,
            'entry.314883736': formData.msg,
        });

        fetch(GOOGLE_FORM_URL, {
            method: 'POST',
            body: payload,
            mode: 'no-cors', 
        })

        .then(() => {
            console.log("Données envoyées à Google Sheets !");
            setformsendet(true);
        })

        .catch((error) => {
            console.error('Erreur lors de la soumission :', error);
        });

        // MAILJS


        setformsended(true);

    };
    
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
        .send(
            "service_q0m46ne",
            "template_teoozoq",
            formData,
            "LkbCNxeLaVdg38waf"
        )
        .then(
            (result) => {
            console.log("Email envoyé :", result.text);
            alert("Message envoyé avec succès !");
            },
            (error) => {
            console.error("Erreur EmailJS :", error.text);
            alert("Une erreur est survenue.");
            }
        );
    };

    const headerClass = show ? 'top-bar-visible' : 'top-bar-hidden';

    return (

        <div className='base_landing_page'>

            {isMobile ? (

                <div className='mobileboxtopbar'>
                    
                    {phonestate ? (

                        <header className={`topbar_base_mobile ${headerClass}`} style={{height:'12vh'}}>

                            <div className='topbarinfo'>
                                
                                <div className='Left_topbar_base_mobile'>

                                </div>

                                <div className='Mid_topbar_base_mobile'>
                                    <input type="image" src={Img.LeSecret_logo_1} />
                                </div>
                                
                                <div className='Rght_topbar_base_mobile' onClick={() => setphonestate(false)}>
                                    <input type="image" src={Img.phone} />
                                </div>

                            </div>

                            <div className='contain_number_contact'>
                                <p>{"02.98.44.03.04"}</p>
                            </div>

                        </header>

                    ) : (

                        <header className={`topbar_base_mobile ${headerClass}`}>

                            <div className='topbarinfo'>
                                
                                <div className='Left_topbar_base_mobile'>

                                </div>

                                <div className='Mid_topbar_base_mobile'>
                                    <input type="image" src={Img.LeSecret_logo_1} />
                                </div>
                                
                                <div className='Rght_topbar_base_mobile' onClick={() => setphonestate(true)}>
                                    <input type="image" src={Img.phone} />
                                </div>

                            </div>

                        </header>
                    )}

                    <div className='topbox_mobile_1' style={{backgroundImage: `url(${Img.salon_2a_2})` }}>

                        <div className='Topcontainbar'>
                        </div>

                        <div className='Midcontainbar'>

                            <input className='centerimgbox' type="image" src={Img.LeSecret_logo_2} />

                            <p>{"Un appartement à Brest,"}</p>
                            <p>{"une liberté à soi."}</p>

                        </div>

                        <div className='Lowcontainbar'>

                            <p className='B1_low_box1'>{"Enfin"}</p>

                            <p 
                                className='B1_low_box1' 
                                style={{marginLeft: '8.7vw', marginTop:'-1%'}}
                            >
                                {"chez moi !"}
                            </p>
                                
                            <p 
                                className='B1_low_box1' 
                                style={{marginLeft: '6vw', fontSize: '2.3vw', marginTop:'-1%', marginBottom:'5%'}}
                            >
                                {"29 rue Mathieu Donnart à Brest"}
                            </p>


                        </div>

                    </div>
                
                </div>

            ) : (

                <div className='computerbox'>

                    <header className={`topbar_base_computer ${headerClass}`}>

                        <div className='topbar_base_l_logo'>
                            <input type="image" src={Img.LeSecret_logo_1}/>
                        </div>

                        <div className='topbar_base_l_sit'>
                            <p>{"Un appartement à Brest, une liberté à soi."}</p>
                        </div>
                    
                        <div className='topbar_base_l_contact'>
                            
                            <div className='p_right_topbar_base_l_contact'>
                                <p>{"02.98.44.03.04"}</p>
                            </div>

                        </div>

                    </header>
                    
                    <div className='box1_computer' style={{backgroundImage: `url(${Img.salon_2a_2})` }}>

                        <div className='mid_box1'>

                            <div className='top_low_box1'>
                                <input type="image" src={Img.LeSecret_logo_2} />
                            </div>

                            <div className='low_low_box1'>
                                <p>{"Un appartement à Brest, une liberté à soi."}</p>
                            </div>

                        </div>

                        <div className='low_box1'>

                            <p className='B1_low_box1'>{"Enfin"}</p>

                            <p 
                                className='B1_low_box1' 
                                style={{marginLeft: '7vw', marginTop:'-1%'}}
                            >
                                {"chez moi !"}
                            </p>
                            
                            <p 
                                className='B1_low_box1' 
                                style={{marginLeft: '6vw', fontSize: '1.7vw', marginTop:'-1%'}}
                            >
                                {"29 rue Mathieu Donnart à Brest"}
                            </p>

                        </div>

                    </div>

                </div>

            )}

            <div className='box2'>
                <p>{"Il y a des lieux qu’on garde pour soi."}</p>
                <p>{"Celui-ci pourrait être le vôtre."}</p>
                <p>{"Un lieu où tout est à sa place,"}</p>
                <p>{"où l’on peut vivre à son rythme."}</p>
                <p
                    style={{marginTop: '2vw'}}
                >
                    {"C’est peut-être ça, la vraie liberté ?"}
                </p>

            </div>

            <div className='box3'>
                <input type="image" src={Img.salon_1} />
            </div>

            <div className='box2'>
                <p>{"Un lieu fait pour les gens"}</p>
                <p>{"qui aiment vivre à leur manière."}</p>
            </div>

            <div className='box4'>
                <input type="image" src={Img.room} />
            </div>
            
            <div className='uneboxcinq'>

                <div className='Top_uneboxcinq'>

                    <div className='inter_top_uneboxcinq'>
                        <p>{"Du T2 au T4,"}</p>
                        <p className='p_inter_top_uneboxcinq'>{"au coeur de Brest "}</p>
                    </div>

                    <div className='inter2_top_uneboxcinq'>
                        <p>{"à partir de 166.000€"}</p>
                    </div>

                </div>

                <div className='low_uneboxcinq'>

                    <div className='lft_low_uneboxcinq'>

                        <div className='box_lft_low_uneboxcinq'>

                            <div className='B_lft_low_uneboxcinq'>

                                <div className='left_or_tri'>
                                    <div className='triangle'></div>
                                </div>

                                <div className='p_B_lft_low_uneboxcinq'>
                                    <p>{"T2 (une chambre) / 10 lots"}</p>
                                </div>

                            </div>

                            <div className='B_lft_low_uneboxcinq'>

                                <div className='left_or_tri'>
                                    <div className='triangle'></div>
                                </div>

                                <div className='p_B_lft_low_uneboxcinq'>
                                    <p>{"T3 (deux chambres) / 9 lots"}</p>
                                </div>
                                    
                            </div>
                                
                            <div className='B_lft_low_uneboxcinq'>

                                <div className='left_or_tri'>
                                    <div className='triangle'></div>
                                </div>

                                <div className='p_B_lft_low_uneboxcinq'>
                                    <p>{"T4 (trois chambres) / 1 lot"}</p>
                                </div>
                                    
                            </div>

                            <div className='F_lft_low_uneboxcinq'>
                                <p>{"1 place de parking / appartement"}</p>
                            </div>

                        </div>

                    </div>

                    <div className='raw_low_uneboxcinq'>
                        <div className='raww'></div>
                    </div>
                        
                    <div className='contain_rgt_low_uneboxcinq'>
                            
                        <div className='rgt_low_uneboxcinq'>
                            <p>{"En plein centre de Brest,"}</p>
                            <p>{"dans un quartier vivant et tout proche des commerces,"}</p>
                            <p>{" Le Secret profite d’un emplacement calme, lumineux, central."}</p>
                            <p>{" Seul, en couple ou en famille, chacun y trouve sa place."}</p>
                        </div>

                    </div>

                </div>
                
            </div>

            <div className='box6'>
                <input type="image" src={Img.build_preview} />
            </div>

            <div className='box7'>

                <div className='img_box7'>
                    <input type="image" src={Img.hall}/>
                </div>
                
                <div className='txt_box7'>
                    <p>{"L’entrée d’un lieu,"}</p>
                    <p>{"c’est déjà une promesse."}</p>
                </div>

            </div>

            <div className='box52'>

                <div className='low_uneboxcinq'>

                    <div className='lft_low_uneboxcinq'>
                    </div>

                    <div className='raw_low_uneboxcinq'>
                        <div className='raww'></div>
                    </div>
                    
                    <div className='rgt_low_uneboxcinq'>
                    </div>
                    
                </div>
                
            </div>

            <div className='box8'>

                <div className='top_title_b8'>
                    <p>{"Prêt à vivre"}</p>
                    <p style={{marginLeft:'0vw'}}>{"début 2026"}</p>
                </div>

                <div className='top_btn_b8'>
                    <div className='btn_top_btn_b8' onClick={scrollToBox11}>
                        <p>{"en savoir plus"}</p>
                    </div>
                </div>

            </div>

            <div className='box3'>
                <input type="image" src={Img.salon_2a} />
            </div>

            <div className='box9'>

                <div className='sit_box9'>
                    <p>{'“La maison, c’est notre coin du monde”'}</p>
                </div>

                <div className='desc_box9'>
                    <p>
                        <span style={{fontFamily:'NowB'}}>{"Gaston Bachelard"}</span>
                        <span>{", La Poétique de l’espace (1957)"}</span>
                    </p>
                </div>

            </div>

            <div className='box10'>

                <div className='B1_box10'>
                    <input type="image" src={Img.interior2} style={{objectPosition:'left center'}}/>
                </div>

                <div className='B2_box10'>

                    <div className='top_B2_box10'>
                        <p style={{marginLeft:'5vw', marginTop: '2vw'}}>{"Le Secret d’une"}</p>
                        <p style={{marginLeft:'1.8vw'}}>{"belle histoire, "}</p>
                        <p style={{marginLeft:'8.6vw'}}>{"c’est Steva."}</p>
                    </div>

                    <div className='low_B2_box10'>

                        <div className='L_low_B2_box10'>
                            <p>{"Le Secret est un projet imaginé et"}</p>
                            <p>{"conçu par l’entreprise familiale"}</p>
                            <p>{"Steva, acteur indépendant de"}</p>
                            <p>{"l’immobilier et de la qualité de vie"}</p>
                            <p>{"depuis plus de vingt ans."}</p>
                                
                        </div>

                        <div className='R_low_B2_box10'>
                            <input type="image" src={Img.steva_logo} />
                        </div>

                    </div>

                </div>

            </div>

            <div className='box10'>

                <div className='B1_box10'>
                    <input type="image" src={Img.interior1} style={{objectPosition:'left center'}}/>
                </div>

                <div className='B1_box10'>
                    <input type="image" src={Img.facade}/>
                </div>

            </div>

            {isMobile ? (

                <div className='box11' id='box-section-11'>

                    <div className='top_box11'>

                        <p>
                            <span style={{marginLeft:'7vw', display: 'block'}}>{"Toutes les bonnes"}</span>
                            <span style={{display: 'block' }}>{" choses ont un début."}</span>
                        </p>

                    </div>

                    <form onSubmit={onFormSubmit} className="formdiv">

                        <div className='Mid_box11'>

                            <div className='Lft_Mid_box11'>

                                <input 
                                    type="text" 
                                    className='Form_box1'
                                    name="name"
                                    placeholder={"Nom (obligatoire)"}

                                    value={formData.nom} 
                                    onChange={handleChange} 
                                />

                                <input 
                                    type="text" 
                                    className='Form_box1'
                                    name="fname"
                                    placeholder={"Prénom (obligatoire)"}

                                    value={formData.fname} 
                                    onChange={handleChange} 
                                />
                                
                                <input 
                                    type="text" 
                                    className='Form_box1'
                                    name="phone"
                                    placeholder={"Téléphone (obligatoire)"}

                                    value={formData.phone} 
                                    onChange={handleChange} 
                                />
                                                            
                                <input 
                                    type="text" 
                                    className='Form_box1'
                                    name="city"
                                    placeholder={"Ville (obligatoire)"}

                                    value={formData.city} 
                                    onChange={handleChange} 
                                />
                                                            
                                <input 
                                    type='text'
                                    className='Form_box1'
                                    name="zip"
                                    placeholder={"Code postal"}

                                    value={formData.zip} 
                                    onChange={handleChange} 
                                />
                                                            
                                <textarea 
                                    type="text" 
                                    className='Form_box2'
                                    name="msg"
                                    placeholder={"Message"}

                                    value={formData.msg} 
                                    onChange={handleChange} 
                                />

                            </div>

                            <div className='Rght_Mid_box11'>
                                
                                {casestate ? (

                                    <div 
                                        className='Case_valid_form'
                                        onClick={() => setcasestate(false)}
                                    >
                                        <input type="image" src={Img.valid} />
                                    </div>

                                ) : (

                                    <div 
                                        className='Case_valid_form'
                                        onClick={() => setcasestate(true)}
                                    >
                                    </div>

                                )}

                                <div className='Txt_legal_Case_valid_form'>
                                    
                                    <p style={{display:'block'}}>
                                        {"En cochant cette case, vous acceptez que STEVA et IZIMMO, en leur qualité de responsables de traitement, utilisent les informations fournies afin de gérer votre demande, ainsi que pour vous communiquer des offres commerciales et des informations sur leurs produits et services par e-mail, téléphone ou SMS."}
                                    </p>
                                    
                                    <p style={{display:'block'}}>
                                        {"Le renseignement des informations demandées est obligatoire pour le traitement de votre demande ; à défaut, celle-ci ne pourra pas être prise en compte.**"}
                                    </p>

                                </div>
                                
                                {formsended ? (

                                    <div className='formsended'>
                                        <p>{"Votre demande a bien été reçue. Nous vous recontacterons dans les plus brefs délais."}</p>
                                    </div>

                                ) : (

                                    <div className='Btn_send_form'>

                                        {casestate && 
                                            (formData.name && 
                                            formData.fname && 
                                            formData.phone && 
                                            formData.city) 
                                        ? (
                                            <button 
                                                type="submit"
                                                className='Box_Btn_send_form'
                                            >
                                                envoyer
                                            </button>
                                        ):(
                                            <div 
                                                className='Box_Btn_send_form'
                                                style={{opacity:'40%'}}
                                            >
                                                <p>envoyer</p>
                                            </div>
                                        )}

                                        <div className='Txt_btn_Btn_send_form'>
                                            <p>{""}</p>
                                        </div>

                                    </div>
                                )}


                            </div>

                        </div>

                    </form>
                    
                    <div className='low_box11'>

                        <div className='L1_low_box11'>

                            <p>

                                <span style={{display:'block'}}>
                                    {"*Vous disposez de droits d’accès, de rectification, d’opposition, d’effacement et de portabilité de vos données, que vous pouvez exercer en contactant STEVA à l’adresse rgpd@villabeausoleil.com ou IZIMMO à l’adresse vosdonneespersonnelles@izimmo.com."}
                                </span>

                                <span>
                                    {"Vos données sont traitées conformément au Règlement (UE) 2016/679 du 27 avril 2016 (RGPD) et à la loi Informatique et Libertés n°78-17 du 6 janvier 1978 modifiée. Pour en savoir plus sur la gestion de vos données personnelles et l’exercice de vos droits, consultez la Politique de protection des données personnelles de STEVA et d’IZIMMO."}
                                </span>

                            </p>

                        </div>

                        <div className='L1_low_box11'>

                            <p style={{fontFamily:'NowB'}}>
                                {"STEVA - 15 rue Gabriel Péri 92120 Montrouge / RCS Nanterre 505 251 413 / SAS au capital de 15 416 880€ / Perspective (visuel non contractuel) : DAR STUDIO RENDER / Réalisation : WALDEN"}
                            </p>

                        </div>

                    </div>

                </div>

            ) : (


                <div className='box11computer' id='box-section-11'>

                    <div className='top_box11computer'>

                        <p>
                            <span style={{marginLeft:'5.5vw', display: 'block'}}>{"Toutes les bonnes"}</span>
                            <span style={{display: 'block' }}>{" choses ont un début."}</span>
                        </p>

                    </div>

                    <form 
                        onSubmit={onFormSubmit} 
                        className="formdiv" >

                        <div className='Mid_box11computer'>

                            <div className='Lft_Mid_box11computer'>

                                <input 
                                    type="text" 
                                    className='Form_box1computer'
                                    name="name"
                                    placeholder={"Nom (obligatoire)"}

                                    value={formData.nom} 
                                    onChange={handleChange} 
                                />

                                <input 
                                    type="text" 
                                    className='Form_box1computer'
                                    name="fname"
                                    placeholder={"Prénom (obligatoire)"}

                                    value={formData.fname} 
                                    onChange={handleChange} 
                                />
                                
                                <input 
                                    type="text" 
                                    className='Form_box1computer'
                                    name="phone"
                                    placeholder={"Téléphone (obligatoire)"}

                                    value={formData.phone} 
                                    onChange={handleChange} 
                                />
                                                            
                                <input 
                                    type="text" 
                                    className='Form_box1computer'
                                    name="city"
                                    placeholder={"Ville (obligatoire)"}

                                    value={formData.city} 
                                    onChange={handleChange} 
                                />
                                                            
                                <input 
                                    type='text'
                                    className='Form_box1computer'
                                    name="zip"
                                    placeholder={"Code postal"}

                                    value={formData.zip} 
                                    onChange={handleChange} 
                                />
                                                            
                                <textarea 
                                    type="text" 
                                    className='Form_box2computer'
                                    name="msg"
                                    placeholder={"message"}

                                    value={formData.msg} 
                                    onChange={handleChange} 
                                />

                            </div>

                            <div className='Rght_Mid_box11computer'>
                                
                                {casestate ? (

                                    <div 
                                        className='Case_valid_formcomputer'
                                        onClick={() => setcasestate(false)}
                                    >
                                        <input type="image" src={Img.valid} />
                                    </div>

                                ) : (

                                    <div 
                                        className='Case_valid_formcomputer'
                                        onClick={() => setcasestate(true)}
                                    >
                                    </div>

                                )}

                                <div className='Txt_legal_Case_valid_formcomputer'>
                                    
                                    <p style={{display:'block'}}>
                                        {"En cochant cette case, vous acceptez que STEVA et IZIMMO, en leur qualité de responsables de traitement, utilisent les informations fournies afin de gérer votre demande, ainsi que pour vous communiquer des offres commerciales et des informations sur leurs produits et services par e-mail, téléphone ou SMS."}
                                    </p>
                                    
                                    <p style={{display:'block'}}>
                                        {"Le renseignement des informations demandées est obligatoire pour le traitement de votre demande ; à défaut, celle-ci ne pourra pas être prise en compte.**"}
                                    </p>

                                </div>

                                {formsended ? (

                                    <div className='formsended'>
                                        <p>{"Votre demande a bien été reçue. Nous vous recontacterons dans les plus brefs délais."}</p>
                                    </div>

                                ) : (

                                    <div className='Btn_send_formcomputer'>

                                        {casestate && 
                                            (formData.name && 
                                            formData.fname && 
                                            formData.phone && 
                                            formData.city) 
                                        ? (
                                            <button 
                                                type="submit"
                                                className='Box_Btn_send_formcomputer'
                                            >
                                                envoyer
                                            </button>
                                        ):(
                                            <div 
                                                className='Box_Btn_send_formcomputer'
                                                style={{opacity:'40%'}}
                                            >
                                                <p>envoyer</p>
                                            </div>
                                        )}

                                        <div className='Txt_btn_Btn_send_formcomputer'>
                                            <p>{""}</p>
                                        </div>

                                    </div>
                                )}

                            </div>

                        </div>
                    </form>

                    <div className='low_box11'>

                        <div className='L1_low_box11'>

                            <p>

                                <span style={{display:'block'}}>
                                    {"**Vous disposez de droits d’accès, de rectification, d’opposition, d’effacement et de portabilité de vos données, que vous pouvez exercer en contactant STEVA à l’adresse rgpd@villabeausoleil.com ou IZIMMO à l’adresse vosdonneespersonnelles@izimmo.com."}
                                </span>

                                <span>
                                    {"Vos données sont traitées conformément au Règlement (UE) 2016/679 du 27 avril 2016 (RGPD) et à la loi Informatique et Libertés n°78-17 du 6 janvier 1978 modifiée. Pour en savoir plus sur la gestion de vos données personnelles et l’exercice de vos droits, consultez la Politique de protection des données personnelles de STEVA et d’IZIMMO."}
                                </span>

                            </p>

                        </div>

                        <div className='L1_low_box11'>

                            <p style={{fontFamily:'NowB'}}>
                                {"STEVA - 15 rue Gabriel Péri 92120 Montrouge / RCS Nanterre 505 251 413 / SAS au capital de 15 416 880€ / Perspective (visuel non contractuel) : DAR STUDIO RENDER / Réalisation : WALDEN"}
                            </p>

                        </div>

                    </div>

                </div>

            )}

        </div>
    )
}

export default Landing_page;
